export default "__VITE_ASSET__DWtzfTA___"